import { ProductUploadWizardService } from 'app/_services/product-upload-wizard.service';
import * as angular from 'angular';

class NetworkPointDetailsOperatorInfoChargesComponentCtrl
    implements ng.IController
{
    public isCreateMode: boolean;
    public isEditMode: boolean;
    public feesExpanded: boolean = true;
    public networkPoint: NetworkPointDto;

    public possibleRuntimes: any = [
        'RUNTIME',
        'YEAR',
        'QUARTER',
        'MONTH',
        'DAY',
        'HOUR'
    ];
    public possiblePhysicalUnits: PhysicalUnit[] = ['K_WH_H', 'K_WH_D'];
    public loadingCurrencies: boolean = true;
    public loadingCurrenciesError: boolean = false;
    private possibleCurrencies: any;

    public addRegulatedTariff: boolean = false;
    public newRegulatedTariff: PriceDto;
    public newRegulatedTariffRuntime: DateInterval;

    constructor(
        private StaticData,
        private productUploadWizardService: ProductUploadWizardService
    ) {}

    $onInit(): void {
        if (this.isCreateMode) {
            this.getCurrencies();
        }
    }

    public removeRegulatedTariff(index: number): void {
        this.networkPoint.capacityTariffs0.splice(index, 1);
    }

    public addNewRegulatedTariff(): void {
        if (!this.networkPoint.capacityTariffs0) {
            this.networkPoint.capacityTariffs0 = [];
        }

        let newTariff: RegulatedTariffDto = {
            priceDto: {
                value: this.productUploadWizardService.getOriginalValue(
                    this.newRegulatedTariff
                ),
                originalValue: this.newRegulatedTariff.originalValue,
                unit: this.productUploadWizardService.getPriceUnitDto(
                    this.newRegulatedTariff,
                    this.newRegulatedTariff
                ),
                originalUnit: this.newRegulatedTariff.originalUnit
            },
            validity: this.newRegulatedTariffRuntime
        };
        this.networkPoint.capacityTariffs0.push(newTariff);
        this.addRegulatedTariff = false;
    }

    private getCurrencies(): void {
        this.StaticData.currenciesForProductUpload(
            (res) => {
                this.possibleCurrencies = res.reverse();
                this.loadingCurrencies = false;
                this.loadingCurrenciesError = false;
            },
            () => {
                this.loadingCurrencies = true;
                this.loadingCurrenciesError = true;
            }
        );
    }
}

angular.module('app').component('pkpNetworkPointDetailsOperatorInfoCharges', {
    controller: NetworkPointDetailsOperatorInfoChargesComponentCtrl,
    template:
        require('app/network-point/network-point-details-operator-info-charges.component.html'),
    bindings: {
        form: '=',
        networkPoint: '=',
        isEditMode: '<',
        isCreateMode: '<'
    }
});
